import { Button } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { NamespacesList } from 'core/enums/common';

import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Error } from 'assets/icons/error.svg';

interface ErrorVerifyEmailModalProps {
	isOpen: boolean;
	onConfirm: () => void;
	onClose?: () => void;
	description?: string;
}

export const ErrorVerifyEmailModal: FC<ErrorVerifyEmailModalProps> = ({
	isOpen,
	onConfirm,
	onClose,
	description,
}) => {
	const { t: modalsTranslate } = useTranslation(NamespacesList['modals']);

	return (
		<InfoModal
			isOpen={isOpen}
			onClose={onClose || onConfirm}
			image={<Error />}
			title={modalsTranslate('errorVerifyEmail.title')}
			description={description}
			buttons={
				<Button
					sx={{
						height: '44px',
						width: { xs: '90%', sm: '438px' },
						borderRadius: '8px',
						textTransform: 'none',
						fontSize: '16px',
						fontWeight: '700',
						marginTop: '24px',
					}}
					type="submit"
					variant="contained"
					color="primary"
					onClick={onConfirm}
				>
					{modalsTranslate('errorVerifyEmail.confirm')}
				</Button>
			}
		></InfoModal>
	);
};
